module.exports = __webpack_public_path__ + "static/adda_main_carouse-ca505d3f85959feed31eb3420473137e.jpg";